import React, { createContext, useContext, useState, useCallback } from 'react';
import s from './style.module.scss';

const ToastContext = createContext(null);

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ message: '', duration: null });

  const showToast = useCallback((message, duration = 3000) => {
    setToast({ message, duration });
    setTimeout(() => setToast({ message: '', duration: null }), duration);
  }, []);

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast.message && <div className={s.toast}>{toast.message}</div>}
    </ToastContext.Provider>
  );
};
